import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { SignOut, ArrowLeft } from "@phosphor-icons/react";

const LOGO_BSVAC = "https://customer-assets.emergentagent.com/job_bedstuy-ems-hub/artifacts/rcm1qmbk_BSVAC%20Patch.png";

/**
 * Chrome for every triage page. Deliberately minimal — a top bar with the
 * BSVAC event-triage branding, the signed-in user's name, and a sign-out
 * button. No sidebar (this is a focused tool, not the full ops console).
 */
export default function TriageLayout({ children, showBack = false }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="triage-layout">
      <header className="bg-white border-b border-slate-200 px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {showBack ? (
            <Button variant="ghost" size="sm" className="rounded-sm" onClick={() => nav("/triage")} data-testid="triage-back">
              <ArrowLeft size={14} weight="bold" className="mr-1" /> Dashboard
            </Button>
          ) : (
            <Link to="/triage" className="flex items-center gap-2">
              <img src={LOGO_BSVAC} alt="BSVAC" className="h-9 w-9 object-contain" />
              <div className="leading-tight">
                <div className="tab-tag text-slate-500">BSVAC · Event Ops</div>
                <div className="font-display font-black tracking-tight text-sm">Event Triage</div>
              </div>
            </Link>
          )}
        </div>
        <div className="flex items-center gap-3">
          <div className="text-right leading-tight hidden sm:block">
            <div className="text-sm font-semibold">{user?.name}</div>
            <div className="tab-tag text-slate-500">Provider</div>
          </div>
          <Button variant="outline" size="sm" className="rounded-sm" onClick={async () => { await logout(); nav("/triage/login"); }} data-testid="triage-signout">
            <SignOut size={14} weight="bold" className="mr-1" /> Sign Out
          </Button>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
